// @flow

export const SET_ACTIVE_FILTER = 'MOBILE_FILTERS/SET_ACTIVE_FILTER';
export const SET_FILTER_VALUE = 'MOBILE_FILTERS/SET_FILTER_VALUE';
export const SET_FILTER_VALUES = 'MOBILE_FILTERS/SET_FILTER_VALUES';
export const GO_BACK = 'MOBILE_FILTERS/GO_BACK';
